import { render, staticRenderFns } from "./menu-mobile.vue?vue&type=template&id=5d44a5dd&scoped=true&lang=pug"
import script from "./menu-mobile.vue?vue&type=script&lang=coffee"
export * from "./menu-mobile.vue?vue&type=script&lang=coffee"
import style0 from "./menu-mobile.vue?vue&type=style&index=0&id=5d44a5dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44a5dd",
  null
  
)

export default component.exports